module.exports = __webpack_public_path__ + "static/media/Gmail.31ed74fc.svg";